import * as actions from './actions';
import reducers from './reducer';

export const Album = { actions, reducers };
export { AlbumState } from './reducer';
